/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import forge, {Middleware} from 'mappersmith'
import type ApolloCustomerClientClientInterface from './ApolloCustomerClientClientInterface'

type FactoryOptions = {
  host?: string
  middleware?: Middleware[]
}

const ApolloCustomerClientClientFactory = ({
  host,
  middleware,
}: FactoryOptions = {}): ApolloCustomerClientClientInterface =>
  forge({
    clientId: 'apollo:client',
    host: host || '',
    middlewares: [...(middleware || [])],
    resources: {
      Documents: {
        metaByIds: {
          path: '/api/v1/documents/metaData',
          method: 'get',
        },
        fetch: {
          path: '/api/v1/documents/{fileId}',
          method: 'get',
          binary: true,
        },
      },
    },
  })

export default ApolloCustomerClientClientFactory
